import React from "react";

const AmountSmallAfterDecimal = ({amount=""}) => {
    if (isNaN(amount)) return ""
    const amount2DecimalPlaces = Number(amount).toFixed(2)  
    const [front, back] = amount2DecimalPlaces.split(".")
    return <React.Fragment>{front}.<em className="small">{back}</em></React.Fragment>
}

export default AmountSmallAfterDecimal